module.exports = __webpack_public_path__ + "img/Untitled-2.744c4eb2.png";